import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_353: DocMigration = {
  maxSchemaVersion: "0.0.353",
  apply(json: any) {
    for (const optionSetId in json.optionSets) {
      const optionSet = json.optionSets[optionSetId];
      if (optionSet.optionSetType === "INTERSECTING") {
        if (Array.isArray(optionSet.scope)) {
          optionSet.scope = optionSet.scope.reduce((acc: any, scope: any) => {
            acc[scope.optionSetId] = scope;
            return acc;
          }, {});
        }
        if (Array.isArray(optionSet.formatting)) {
          optionSet.formatting = optionSet.formatting.reduce((acc: any, formatting: any, sortIndex: number) => {
            const { templateCode, ...rest } = formatting;
            const id = uid();
            acc[id] = {
              ...rest,
              id,
              sortIndex,
              builderTemplateCode: templateCode,
            };
            return acc;
          }, {});
        }
      } else {
        for (const optionId in optionSet.options) {
          const { templateCode, ...rest } = optionSet.options[optionId];
          if (templateCode !== undefined) {
            json.optionSets[optionSetId].options[optionId] = {
              ...rest,
              builderTemplateCode: templateCode,
            };
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_353;
